import TagManager from 'react-gtm-module'

export function sendChangeAccommodationGTM(priceChange: number, priceChangePerRoom: number): void {
  TagManager.dataLayer({
    dataLayer: {
      event: 'change_accommodation',
      total_price_change: priceChange,
      total_price_change_per_room: priceChangePerRoom,
    },
  })
}
